import { useMemo } from "react";
import { Product } from "../../../types/working-model";
import ModalComponent from "../../general-ui/modal/modal";

interface DeleteProductConfirmationProps {
	onConfirm: (product?: Product) => void;
	onClose: () => void
	open: boolean;
	product?: Product;
	replacing?: boolean;
}

const DeleteProductConfirmation: React.FC<DeleteProductConfirmationProps> = ({
	onConfirm,
	onClose,
	open,
	product,
	replacing
}) => {
	const close = () => {
		onClose();
	};

	const confirm = () => {
		onConfirm(product);
		onClose();
	};

	const modalBody = useMemo(() => {
		if (replacing) {
			return "Any changes made to the product being replaced will be permanently lost and need to be redone.";
		} else {
			return "Any changes made to the original will be permanently lost and need to be redone.";
		}
	}, [replacing]);

	return (
		<ModalComponent
			title={`${replacing ? 'Replace' : 'Delete'} this Product?`}
			open={open}
			onRequestClose={close}
			closeable
			cancellable
			footer={
				<>
					<div />
					<div>
						<button onClick={close}>Cancel</button>
						<button className="primary" onClick={confirm}>{replacing ? 'Replace' : 'Delete'}</button>
					</div>
				</>
			}
		>
			<div>
				<p>{modalBody}</p>
			</div>
		</ModalComponent>
	);
};

export default DeleteProductConfirmation;